import React, { useContext, useState } from "react";
import Topbar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import { Container, Tab, Tabs } from "react-bootstrap";
import Button from "../../../components/ButtonComponent/Button";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import EditIcon from "../../../assets/images/Icons/pencilIcon.svg";
import AciveIcon from "../../../assets/images/Icons/activeEyeIcon.svg";
import InaciveIcon from "../../../assets/images/Icons/inactiveEyeIcon.svg";
import { VisitorsMappingContext } from "../VisitorsMappingView";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import DropdownList from "../../../constants/contentFile.json";
import "./visitorsMapping.css";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
import { Spinner } from "react-bootstrap";
const VisitorsMapping = ({ textContent }) => {
  const {
    guestRegister,
    visitorsDetails,
    filterCriteria,
    setFilterCriteria,
    goBack,
    editVisitorDetails,
    visitorsData,
    showAlert,
    setShowAlert,
    alertMessage,
    handleMagneticUpload,
    fileErrorMessage,
    setAlertMessage,
    handleAlertSubmit,
    setStatusData,
    logout,
    visitorsDataOne,
    visitorsDataTwo,
    statusCode,
    categoryRequired,

    // zone table pagination
    allZonePageNumber,
    zoneOnePageNumber,
    zoneTwoPageNumber,

    // Zone table page count
    allZonePageCount,
    zoneOnePageCount,
    zoneTwoPageCount,

    onSelectTab, // function on select tab
    // on page change
    onPageChangeAllZone,
    onPageChangeZoneTwo,
    onPageChangeZoneOne,
    spinnerStatus
  } = useContext(VisitorsMappingContext);
  const Content = TableBody.visitorsMapping;
  const [status, setStatus] = useState("active");
  const tableHeader = [
    {
      title: "Name & Contact",
      prop: "VisitorName",
      cell: (row) => (
        <div
          className="ertHeaderEvacuation"
          onClick={() => {
            visitorsDetails(row.VisitorId);
          }}
        >
          <div>{row.VisitorName}</div>
          <div>{row.VisitorPhoneNo}</div>
        </div>
      ),
    },
    // { title: "Current Zone", prop: "DeviceFName" },
    { title: "Visitor Type", prop: "CategoryFName" },
    { title: "Magnetic Card ID ", prop: "MagneticId" },
    {
      title: "Date",
      prop: "Date",
      cell: (row) => (
        <div className="ertHeaderEvacuation">{row?.Date?.slice(0, 10)}</div>
      ),
    },

    {
      prop: "status1",
      cell: (row) => (
        <div className="editable-buttons">
          {row.status1 == "active" ? (
            <img
              src={AciveIcon}
              alt="status icon"
              onClick={() => {
                setStatus("inactive");
              }}
            />
          ) : (
            <img
              src={InaciveIcon}
              alt="status icon"
              onClick={() => {
                setStatus("active");
              }}
            />
          )}
          <img
            src={EditIcon}
            alt="Edit icon"
            onClick={() => editVisitorDetails(row.VisitorId)}
          />
        </div>
      ),
    },
  ];
  const criteriaList = DropdownList.filterVisitor;
  return (
    <div className="visitors-page settings">
      {spinnerStatus && (
                <div className="spinner-overlay-vehicle-report">
                  <Spinner size="xl" className="custom-spinner-vehicle-report" />
                </div>
              )}
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => handleAlertSubmit()
        }
      />
      <Topbar />
      <Container className="my-4">
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
              onClick={() => goBack()}
            />
            <p className="title-name">{textContent.title}</p>
          </div>
          <div className="filterButtons">
            <Button
              text={textContent.buttonText}
              onClick={() => {
                guestRegister();
              }}
            />
          </div>
        </div>
        <Tabs
          onSelect={(e) => {
            onSelectTab(e);
          }}
        >
          <Tab eventKey="0" title={`All`}>
            <DataTable
              tableData={visitorsData}
              header={tableHeader}
              isPagination={true}
              onPageChange={(e) => onPageChangeAllZone(e)}
              currentPage={allZonePageNumber}
              pageCount={allZonePageCount}
            />
          </Tab>
          <Tab eventKey="1" title={`Zone 1`}>
            <DataTable
              tableData={visitorsDataOne}
              header={tableHeader}
              isPagination={true}
              onPageChange={(e) => onPageChangeZoneOne(e)}
              currentPage={zoneOnePageNumber}
              pageCount={zoneOnePageCount}
            />
          </Tab>
          <Tab eventKey="2" title={`Zone 2`}>
            <DataTable
              tableData={visitorsDataTwo}
              header={tableHeader}
              isPagination={true}
              onPageChange={(e) => onPageChangeZoneTwo(e)}
              currentPage={zoneTwoPageNumber}
              pageCount={zoneTwoPageCount}
            />
          </Tab>
        </Tabs>
      </Container>
    </div>
  );
};

export default VisitorsMapping;
